import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserDto } from '../../interfaces/marina.interface';

@Component({
  selector: 'marina-topbar-user-menu',
  templateUrl: './topbar-user-menu.component.html',
  styleUrl: './topbar-user-menu.component.scss',
})
export class TopbarUserMenuComponent implements OnInit {
  @Input() currentUser$!: Observable<UserDto | null>;
  @Input() userDisplayName?: string; // Optional override for display name (e.g., "System Administrator")
  @Input() showDeviceManagement: boolean = true; // Show device management menu item
  @Input() deviceManagementRoute: string = '/devices'; // Route for device management

  @Output() logout = new EventEmitter<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (!this.currentUser$) {
      console.warn('TopbarUserMenuComponent: currentUser$ input is required');
    }
  }

  getUserInitials(user: UserDto): string {
    const displayName = user ? (user.name || [user.firstName, user.lastName].filter(Boolean).join(' ').trim()) : '';
    if (!displayName) {
      return 'U';
    }
    const names = displayName.trim().split(/\s+/);
    if (names.length >= 2) {
      return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return displayName.substring(0, 2).toUpperCase();
  }

  getUserDisplayName(user: UserDto): string {
    const displayName = user ? (user.name || [user.firstName, user.lastName].filter(Boolean).join(' ').trim()) : '';
    return this.userDisplayName || displayName || 'User';
  }

  onLogout(): void {
    this.logout.emit();
  }

  onNavigateToDevices(): void {
    // Material menu closes automatically on menu item click
    this.router.navigate([this.deviceManagementRoute]);
  }
}
